import React from 'react'
import Box from '@mui/material/Box';
import MuiDrawer from '@mui/material/Drawer';
import {Typography, Button} from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import QuizDay from './QuizDay';
import {Link} from 'react-router-dom';

const drawerWidth = 240;

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));


  const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  }));
  

function StdDashboardContent(props) {
  return (
    <Box component="main" sx={{ flexGrow: 1, p: 3}}>
        <DrawerHeader />
        <Box style={{display: props.quizStatus?'none':'block'}}>
          <Typography paragraph>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
            tempor incididunt ut labore et dolore magna aliqua. Rhoncus dolor purus non
            enim praesent elementum facilisis leo vel. Risus at ultrices mi tempus
            imperdiet. Semper risus in hendrerit gravida rutrum quisque non tellus.
            Convallis convallis tellus id interdum velit laoreet id donec ultrices.
            Odio morbi quis commodo odio aenean sed adipiscing. Amet nisl suscipit
            adipiscing bibendum est ultricies integer quis. Cursus euismod quis viverra
            nibh cras. Metus vulputate eu scelerisque felis imperdiet proin fermentum
            leo. Mauris commodo quis imperdiet massa tincidunt. Cras tincidunt lobortis
            feugiat vivamus at augue. At augue eget arcu dictum varius duis at
            consectetur lorem. Velit sed ullamcorper morbi tincidunt. Lorem donec massa
            sapien faucibus et molestie ac.
          </Typography>
          <Typography paragraph>
            Consequat mauris nunc congue nisi vitae suscipit. Fringilla est ullamcorper
            eget nulla facilisi etiam dignissim diam. Pulvinar elementum integer enim
            neque volutpat ac tincidunt. Ornare suspendisse sed nisi lacus sed viverra
            tellus. Purus sit amet volutpat consequat mauris. Elementum eu facilisis
            sed odio morbi. Euismod lacinia at quis risus sed vulputate odio. Morbi
            tincidunt ornare massa eget egestas purus viverra accumsan in. In hendrerit
            gravida rutrum quisque non tellus orci ac. Pellentesque nec nam aliquam sem
            et tortor. Habitant morbi tristique senectus et. Adipiscing elit duis
            tristique sollicitudin nibh sit. Ornare aenean euismod elementum nisi quis
            eleifend. Commodo viverra maecenas accumsan lacus vel facilisis. Nulla
            posuere sollicitudin aliquam ultrices sagittis orci a.
          </Typography>
        </Box>
        <Box sx={{display: props.quizStatus?'block':'none'}}>
          <Box sx={{ width: '40%', margin:'auto', marginTop:'15px' }}>
            <Stack spacing={3}>
              <Item>
                <Button style={{width:'100%', padding:'10px'}}>
                  <Link to="/quizday_1">Day 1</Link>
                </Button>
              </Item>
              <Item>
                <Button style={{width:'100%', padding:'10px'}} disabled>Day 2</Button>
              </Item>
              <Item>
                <Button style={{width:'100%', padding:'10px'}} disabled>Day 3</Button>
              </Item>
              <Item>
                <Button style={{width:'100%', padding:'10px'}} disabled>Day 4</Button>
              </Item>
              <Item>
                <Button style={{width:'100%', padding:'10px'}} disabled>Day 5</Button>
              </Item>
            </Stack>
          </Box>
        </Box>
        <QuizDay/>
      </Box>
      
  )
}

export default StdDashboardContent